module.exports = __webpack_public_path__ + "img/a4adf8d.png";